'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var initialState = function initialState() {
  return {
    track: function track() {
      throw new Error('`tracker.track` is used before it is initialized');
    },
    setProperties: function setProperties() {
      throw new Error('`tracker.setProperties` is used before it is initialized');
    },
    clone: function clone() {
      throw new Error('`tracker.clone` is used before it is initialized');
    }
  };
};

var tracker = function tracker() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return state;
};

exports.default = tracker;
module.exports = exports['default'];